<div class="modal-body vtr-modal-voice">
	<div class="row justify-content-end">
		<!-- <div class="btn-close">
				<button type="button"
					class="close"
					aria-hidden="true"
					(click)="closeModal()">
					<fa-icon [icon]="['fal', 'times']"></fa-icon>
				</button>
			</div> -->
		<a role="button"
			type="button"
			href="javascript:;"
			class="close-btn"
			(click)="closeModal()"
			tabindex="1"
			(keydown.enter)="closeModal()"
			aria-label="smartAssist voice modal close"
			id="device-smartAssist-voice-modal-close">
			<img [src]=" 'assets/icons/Close.svg' | svgInline | async"
				srcset="">
		</a>
	</div>
	<h1 class="mb-3"
		*ngIf="value=='voiceToText'">
		{{'device.smartAssist.voice.voiceToText.title' | translate}}</h1>
	<h1 class="mb-3"
		*ngIf="value=='translation'">
		{{'device.smartAssist.voice.translation.title' | translate}}</h1>
	<h1 class="mb-3 sub-heading">{{'device.smartAssist.voice.modalPopUp.heading' | translate}}</h1>
	<div class="row">
		<div class="col">
			<div class="number-list">
				<li>
					<div class="d-flex justify-content-start align-tems-center mb-2 mr-2">
						<div class="serial-bakcground">
							<p class="serial">1.</p>
						</div>
						<span *ngIf="lowerCaseValue === 'voicetotext'"
							role="text"
							class="text-regular"
							id="voice-modal-{{value}}-point-1"
							attr.aria-label="voice-modal-{{value}}-point-1">{{'device.smartAssist.voice.modalPopUp.point1' | translate}}</span>
						<span *ngIf="lowerCaseValue === 'translation'"
							role="text"
							class="text-regular"
							id="voice-modal-{{value}}-point-1"
							attr.aria-label="voice-modal-{{value}}-point-1">{{'device.smartAssist.voice.modalPopUp.point10' | translate}}</span>
					</div>
				</li>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col">
			<div class="number-list">
				<li>
					<div class="d-flex justify-content-start mb-2 mr-2">
						<div class="">
							<p class="serial serial2">2.</p>
						</div>
						<span role="text"
							class="text-regular"
							*ngIf="value=='voiceToText'"
							id="voice-modal-{{value}}-point-2"
							attr.aria-label="voice-modal-{{value}}-point-2">{{'device.smartAssist.voice.modalPopUp.point2' | translate}}</span>
						<span role="text"
							class="text-regular"
							*ngIf="value=='translation'"
							id="voice-modal-{{value}}-point-2"
							attr.aria-label="voice-modal-{{value}}-point-2">{{'device.smartAssist.voice.modalPopUp.point6' | translate}}</span>
					</div>
				</li>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col">
			<div class="number-list">
				<li>
					<div class="d-flex justify-content-start mb-2 mr-2">
						<div class="">
							<p class="serial serial2">3.</p>
						</div>
						<span role="text"
							class="text-regular"
							*ngIf="value=='voiceToText'"
							id="voice-modal-{{value}}-point-3"
							attr.aria-label="voice-modal-{{value}}-point-3">{{'device.smartAssist.voice.modalPopUp.point3' | translate}}</span>
						<span role="text"
							class="text-regular"
							*ngIf="value=='translation'"
							id="voice-modal-{{value}}-point-3"
							attr.aria-label="voice-modal-{{value}}-point-3">{{'device.smartAssist.voice.modalPopUp.point7' | translate}}</span>
					</div>
				</li>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col">
			<div class="number-list">
				<li>
					<div class="d-flex justify-content-start mb-2 mr-2">
						<div class="">
							<p class="serial serial2">4.</p>
						</div>
						<span role="text"
							class="text-regular"
							*ngIf="value=='voiceToText'">{{'device.smartAssist.voice.modalPopUp.point4' | translate}}</span>
						<span role="text"
							class="text-regular"
							*ngIf="value=='translation'">{{'device.smartAssist.voice.modalPopUp.point8' | translate}}</span>
					</div>
				</li>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col">
			<div class="number-list">
				<li>
					<div class="d-flex justify-content-start mb-2 mr-2">
						<div class="">
							<p class="serial">5.</p>
						</div>
						<span role="text"
							class="text-regular"
							*ngIf="value=='voiceToText'">{{'device.smartAssist.voice.modalPopUp.point5' | translate}}</span>
						<span role="text"
							class="text-regular"
							*ngIf="value=='translation'">{{'device.smartAssist.voice.modalPopUp.point9' | translate}}</span>
					</div>
				</li>
			</div>
		</div>
	</div>
	<div class="line"></div>
	<div class="row">
		<button class="btn close-button"
			role="button"
			(click)="closeModal()"
			(keydown.enter)="closeModal()"
			aria-label="voice modal close"
			id="device-smartAssist-voice-modal-close-button">{{'device.smartAssist.voice.modalPopUp.closeText' | translate}}</button>
	</div>
</div>
